import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeResource',
})
export class SafeResourcePipe implements PipeTransform {
    public constructor(private sanitizer: DomSanitizer) {
    }

    public transform(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/pipes/safe-resource.pipe.ts